import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class SalesOrderCancelledActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Bakery/SalesOrderOnline/SalesOrderHistoryBrowser")
	}

	render() {
		return (
			<Activity 
				name="SalesOrder.cancelledBrowse"
				RenderedComponent={this.RenderedComponent}
				context="cancelled"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(SalesOrderCancelledActivity)
